import { render, staticRenderFns } from "./ExternalNotFound.vue?vue&type=template&id=2b00b2d0&"
import script from "./ExternalNotFound.vue?vue&type=script&lang=js&"
export * from "./ExternalNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports